import SubmitingForm from './submitingForm';

export default (() => {
    const submitedForm = new SubmitingForm();

    submitedForm.init();
})();